import React from "react";

export interface IAppContext {
  setLoaderVisible: (isVisible: boolean) => void;
}

export const initialAppContext: IAppContext = {
  setLoaderVisible: isVisible => {
    var el = document.querySelector(".loader");
    if (el) {
      if (isVisible) {
        if (el.className.indexOf("with-background") > -1) {
          el.className = "loader with-background is-spinning";
        } else {
          el.className = "loader is-spinning";
        }
      } else if (el.className.indexOf("is-spinning") > -1) {
        var delay = 500;
        if (el.className.indexOf("with-background") > -1) {
          delay = 1100;
          setTimeout(function() {
            el!.className = "loader with-background is-spinning is-fading";
          }, 100);
        } else {
          setTimeout(function() {
            el!.className = "loader is-spinning is-fading";
          }, 200);
        }
        setTimeout(function() {
          el!.className = "loader";
        }, delay + 200);
      }
    }
  }
};

export const AppContext = React.createContext<IAppContext>(initialAppContext);
